import OverallScoreboardContainer from "./OverallScoreboardContainer";
import CountryScoreboardContainer from "./CountryScoreboardContainer";
import { getTranslations, isMobile } from "../../../Common/utils";
import { useSelector } from "react-redux";
import SectionLoader from "../../Loaders/SectionLoader";
import { NoDataFound } from "../../NoDataFound";

const OverallHeadtoHead = ({ handleHeadToHeadViewGamedayIdChange }) => {
  const leagueState = useSelector((state) => state.league);
  const overallLayoutVariant = isMobile() ? "stacked" : "inline-header";
  const countryLayoutVariant = isMobile() ? "top-header" : "inline-header";

  const {
    getSingleRaceH2HData,
    getSingleRaceH2HLoading,
    getSingleRaceH2HError,
    selectedLeague,
  } = leagueState;

  const hasOpponentJoined = selectedLeague?.member_count === 2;

  if (getSingleRaceH2HLoading) {
    return <SectionLoader />;
  }

  if (getSingleRaceH2HError) {
    return <div>Error: {getSingleRaceH2HError}</div>;
  }

  return (
    <>
      <OverallScoreboardContainer
        layoutConfig={{ variant: overallLayoutVariant }}
        overallResult={getSingleRaceH2HData?.overall}
      />
      {(!hasOpponentJoined || !getSingleRaceH2HData?.gamedays?.length) && (
        <div className="si-h2h--empty-container">
          <NoDataFound
            noDataTitle={
              !hasOpponentJoined
                ? getTranslations(
                  "h2h_opponent_hasnt_joined",
                  "Opponent hasn't joined yet"
                )
                : !getSingleRaceH2HData?.gamedays?.length
                  ? getTranslations(
                    "h2h_waiting_for_track_action",
                    "Waiting for track action to start"
                  )
                  : null
            }
          />
        </div>
      )}
      {getSingleRaceH2HData?.gamedays
        ?.slice()
        .sort((a, b) => {
          const roundIdA = a?.round_id || 0;
          const roundIdB = b?.round_id || 0;
          return roundIdB - roundIdA;
        })
        .map((gameday) => (
          <CountryScoreboardContainer
            key={gameday.round_id}
            layoutConfig={{ variant: countryLayoutVariant }}
            countryResult={gameday}
            handleHeadToHeadViewGamedayIdChange={
              handleHeadToHeadViewGamedayIdChange
            }
          />
        ))}
    </>
  );
};

export default OverallHeadtoHead;
